module.exports = __webpack_public_path__ + "img/pc_character2@2x.7ec6298f.png";